import React from "react"
import { GatsbyImage} from "gatsby-plugin-image"

import parse from "html-react-parser"

import './hero_image_and_video_content.scss'

const HeroImageAndVideoContents = ({featuredImage, heroContent}) => {

  return(
    <div className="hero-content">
      <div className="hero-featured-image-content">
        {
          featuredImage.data !== undefined && !heroContent.video ? 
            <GatsbyImage layout="fill" image={featuredImage.data} alt={featuredImage.alt} style={{borderRadius:"5px"}} />
          :<div className="hero-featured-video-content">
            {parse(heroContent.video)}
            {parse(heroContent.videoText)}
          </div>
        }
      </div>
    </div>
  )
}

export default HeroImageAndVideoContents;
